export default "<router-outlet></router-outlet>\n<app-toast-container></app-toast-container>";